// Set environment based on NODE_ENV
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT 
                   

// API URL based on environment
let API_URL = process.env.REACT_APP_API_URL_STAGING 
if(ENVIRONMENT === 'production') API_URL = process.env.REACT_APP_API_URL_PRODUCTION


console.log("Current environment:", ENVIRONMENT);

// for AWS (s3 bucket)
export const imageUrl = (url) => `${API_URL}/api/images/${url}`;

/**
 * Creates a full API URL
 * @param {String} link
 * @returns {String}
 */
export const BaseURL = (link) => `${API_URL}/api/${link}`;

// Export for use in the app
export const config = {
  apiUrl: API_URL,
  environment: ENVIRONMENT,
  isDevelopment: ENVIRONMENT === 'development',
  isProduction: ENVIRONMENT === 'production',
};

export const apiHeader = (token, isFormData, additionalOptions = {}) => {
  if (token && !isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  } else if (token && isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      ...additionalOptions,
    };
  } else if (!token && !isFormData) {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  } else if (!token && isFormData) {
    return {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
  }
};
